import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';

import { Auth0Context } from './auth0-context';

export const Auth0Wrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <Auth0Provider
            domain={import.meta.env.VITE_AUTH0_DOMAIN}
            clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/callback`,
                audience: import.meta.env.VITE_AUTH0_AUDIENCE,
                scope: 'read:all openai profile email',
            }}
            cacheLocation="localstorage"
        >
            <Auth0ContextProvider>{children}</Auth0ContextProvider>
        </Auth0Provider>
    )
};

export const Auth0ContextProvider = ({ children }: { children: React.ReactNode }) => {
    const auth0 = useAuth0();
    const logout = () => auth0.logout({ logoutParams: { returnTo: window.location.origin } });

    return (
        <Auth0Context.Provider value={{ ...auth0, logout }}>
            {children}
        </Auth0Context.Provider>
    )
};
